import { configureStore, combineReducers } from "@reduxjs/toolkit"
import {
	persistStore,
	persistReducer,
	FLUSH,
	REHYDRATE,
	PAUSE,
	PERSIST,
	PURGE,
	REGISTER
} from "redux-persist"

import uiReducer from "./slices/uiSlice"
import contactReducer from "./slices/contactSlice"
import localizationReducer from "./slices/localizationSlice"

// SSR-safe storage - use noop storage during SSR
const createNoopStorage = () => {
	return {
		getItem(_key: string) {
			return Promise.resolve(null)
		},
		setItem(_key: string, value: string) {
			return Promise.resolve(value)
		},
		removeItem(_key: string) {
			return Promise.resolve()
		}
	}
}

// Always use noop storage - we'll skip persistence entirely to avoid hydration issues
const storage = createNoopStorage()

const rootReducer = combineReducers({
	ui: uiReducer,
	contact: contactReducer,
	localization: localizationReducer
})

const persistConfig = {
	key: "dingoo-website",
	version: 1,
	storage,
	whitelist: [] // Disable persistence to debug the hydration issue
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
	reducer: persistedReducer,
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
			}
		})
})

export const persistor = persistStore(store)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
